// extracted by mini-css-extract-plugin
export default {"ddItem":"styles_ddItem__f0pD4"};